import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY, HAVE_PET_END_REASON, PET_TYPE} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {getFormattedDate} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'

interface Props {
    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    petType: Nullable<string>
    petBreed: Nullable<string>
    havePetEndDate: Nullable<string>
    havePetEndReason: Nullable<string>
    otherReason: Nullable<string>
    applyFlag?: boolean
}

const NatResidentPetBreedingStopConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName, applicantFirstName, petType, petBreed,
        havePetEndDate, havePetEndReason, otherReason
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.BREEDING_PETS_CANCEL.label

    const petTypeLabel = (petType) ? PET_TYPE.codeToEnumConstants(petType).label : ''

    const petBreedLabel = petBreed ?? ''

    const havePetEndDateLabel = (havePetEndDate) ?
        getFormattedDate(havePetEndDate) : ''

    const havePetEndReasonLabel = (havePetEndReason) ?
        HAVE_PET_END_REASON.codeToEnumConstants(havePetEndReason).label : ''

    const otherReasonLabel = otherReason ?? ''

    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
                <BlockSpacer height={'5px'}/>
            </>
        }
        <NatResidentApplicationDetailConfirmItem
            title={'種類'}
            items={[petTypeLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'品種'}
            items={[petBreedLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'飼育中止日'}
            items={[havePetEndDateLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'飼育中止理由'}
            items={
                havePetEndReason === HAVE_PET_END_REASON.OTHER.value
                    ? [havePetEndReasonLabel, otherReasonLabel]
                    : [havePetEndReasonLabel]}
        />
    </>)
}

NatResidentPetBreedingStopConfirm.displayName = 'NatResidentPetBreedingStopConfirm'
export default NatResidentPetBreedingStopConfirm